<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="items">
      <div
        class="item van-hairline--bottom"
        @click="changeLang('en', $event)"
      >
        <div class="flex_center">
          <div class="info">English</div>
        </div>
        <div v-if="lang == 'en'">✓</div>
      </div>
      <div
        class="item van-hairline--bottom"
        @click="changeLang('ja', $event)"
      >
        <div class="flex_center">
          <img src="img/ja.png" alt="" class="lang-icon" v-if="hasJaIcon"/>
          <div class="info">Japanese</div>
        </div>
        <div v-if="lang == 'ja'">✓</div>
      </div>
      <div
        class="item van-hairline--bottom"
        @click="changeLang('kr', $event)"
      >
        <div class="flex_center">
          <div class="info">Korean</div>
        </div>
        <div v-if="lang == 'kr'">✓</div>
      </div>
      <div
        class="item van-hairline--bottom"
        @click="changeLang('zh', $event)"
      >
        <div class="flex_center">
          <div class="info">Chinese</div>
        </div>
        <div v-if="lang == 'zh'">✓</div>
      </div>
    </div>
  </div>
</template>

<script>
import { setVantLocale } from '../../common/vantLocale';

export default {
  data() {
    return {
      lang: this.$i18n.locale,
      hasJaIcon: false
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      setVantLocale(lang);
      localStorage.setItem('lang', lang);
      this.lang = lang;
      this.$toast.success(this.$t('common.success'));
    }
  },
  created() {
    // 检查是否有日语图标
    const img = new Image();
    img.onload = () => {
      this.hasJaIcon = true;
    };
    img.src = 'img/ja.png';
  }
};
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  background-color: #1f1c1f;
}

.nav-bar {
  background: #1f1c1f;
}

.items {
  padding: 20px;
}

.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 20px;
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  border-radius: 16px;
  margin-bottom: 20px;
  color: #fff;
  cursor: pointer;
}

.flex_center {
  display: flex;
  align-items: center;
}

.info {
  font-size: 28px;
  color: #e6b98a;
}

.lang-icon {
  width: 40px;
  height: 40px;
  margin-right: 15px;
}
</style>
